import React from "react";
import '../../App.css';

export default function Blogs() {
    return <h1 className="ph-text">Blog Coming Soon!</h1>;
}